import { IInputProps } from 'types/components/inputs/input.interface';
import InputWrapper from '../wrapper/InputWrapper';

const TextInput = (props: IInputProps) => {
  return (
    <InputWrapper
      {...props}
      render={inputProps => <input {...inputProps} />}
    />
  );
};

export default TextInput;
